import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DELETE, GET, POST, PUT } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";


// Thunk for posting Form
export const postAppointmentForm = createAsyncThunk(
    "post-appointment",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await POST(`${API.APPOINTMENT_FORM}`, data);
            if (response?.success) {
                return response;
            }
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updateAppointmentForm = createAsyncThunk(
    "put-appointment",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await PUT(`${API.APPOINTMENT_FORM}/${id}`, data);
            if (response?.data?.success) {
                return response?.data;
            }
            return rejectWithValue(response?.data);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getAppointments = createAsyncThunk(
    "get-appointments",
    async (_, { rejectWithValue }) => {
        try {
            const response = await GET(`${API.APPOINTMENT_FORM}`);
            return response?.data;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getAppointment = createAsyncThunk(
    "get-appointment",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await GET(`${API.APPOINTMENT_FORM}/${id}`);

            return response?.data;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const cancleAppointment = createAsyncThunk(
    "get-appointment",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await DELETE(`${API.APPOINTMENT_FORM}/${id}`);

            return response?.data;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



// Create the slice
const formSlice = createSlice({
    name: "appointments",
    initialState: {
        appointment: {},
        appointments: [],
        formData: [],
        error: null,
        status: "idle",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postAppointmentForm.pending, (state) => {
                state.status = "loading";
                console.log("State after pending", state);
            })
            .addCase(postAppointmentForm.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.formData = action.payload;
            })
            .addCase(postAppointmentForm.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
                console.log("State after rejected", state);
            })

            .addCase(getAppointment.pending, (state) => {
                state.status = "loading";
                console.log("State after pending", state);
            })
            .addCase(getAppointment.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.appointment = action.payload || [];
            })
            .addCase(getAppointment.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
                console.log("State after rejected", state);
            })

            .addCase(getAppointments.pending, (state) => {
                state.status = "loading";
                console.log("State after pending", state);
            })
            .addCase(getAppointments.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.appointments = action.payload || [];
            })
            .addCase(getAppointments.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
                console.log("State after rejected", state);
            });

    },
});

export default formSlice.reducer;
